import React from "react"
import { TagWrapper } from "../elements"

export const Tag = ({ children, href }) => {
  return <TagWrapper to={href}>{children}</TagWrapper>
}
